<template>
    <div>
        <div v-if="loading" class="mascom-loader"></div>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    }
};
</script>
